import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function Terms() {
  return (
    <LegalPage title="Terms of Service" lastUpdated="June 12, 2026">
      <p>
        Welcome to KELTA — Kerala Local Body Technical Assistants Association ("KELTA",
        "we", "us", "our"). These Terms of Service ("Terms") govern your access to and
        use of <strong>kelta.co.in</strong> and any related services (collectively, the "Service").
        By creating an account, paying membership fees, or otherwise using the Service,
        you agree to be bound by these Terms.
      </p>

      <h2>1. Eligibility & Membership</h2>
      <p>
        KELTA membership is open to Technical Assistants and equivalent technical staff
        serving in Grama Panchayats, Block Panchayats, District Panchayats, Municipalities
        and Corporations across the State of Kerala. By registering, you confirm that the
        information you provide (including your employee ID, designation, department,
        district and local body) is true, accurate and complete.
      </p>

      <h2>2. Account Registration</h2>
      <ul>
        <li>You must provide a valid email, mobile number and other required details during registration.</li>
        <li>You are responsible for maintaining the confidentiality of your password and for all activity under your account.</li>
        <li>You agree to notify KELTA immediately of any unauthorised use of your account.</li>
        <li>KELTA reserves the right to suspend or terminate accounts that violate these Terms or association rules.</li>
      </ul>

      <h2>3. Membership Fees</h2>
      <p>
        Membership requires payment of the prescribed annual fee. The fee amount is
        displayed at the time of payment. Membership becomes active only after:
      </p>
      <ol>
        <li>Successful online payment via our payment partner (Razorpay), and</li>
        <li>Verification and approval by a KELTA administrator.</li>
      </ol>
      <p>
        Payments are processed by Razorpay Software Private Limited. KELTA does not
        store your card or banking credentials at any time.
      </p>

      <h2>4. Acceptable Use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Impersonate any other person or misrepresent your affiliation with any local body.</li>
        <li>Upload or share content that is unlawful, defamatory, obscene or infringing on intellectual property.</li>
        <li>Attempt to gain unauthorised access to the Service, other accounts, or its underlying infrastructure.</li>
        <li>Use the Service to send spam or unsolicited communications.</li>
        <li>Use any data obtained from the Member Directory for commercial solicitation.</li>
      </ul>

      <h2>5. Digital Membership Card</h2>
      <p>
        Each approved member receives a unique digital membership identifier (e.g.,
        <code> KELTA-2026-00001</code>) and a QR-verifiable digital ID card. The
        membership ID and digital card are issued solely for the purpose of identifying
        the member as a KELTA participant; misuse for any other purpose is strictly
        prohibited.
      </p>

      <h2>6. Content & Intellectual Property</h2>
      <p>
        All content published on the Service by KELTA — including text, graphics, the
        KELTA emblem, circulars, knowledge base articles, and gallery photographs — is
        the property of KELTA or its content contributors and is protected by applicable
        intellectual property laws.
      </p>

      <h2>7. Limitation of Liability</h2>
      <p>
        The Service is provided on an "as is" and "as available" basis. To the maximum
        extent permitted by law, KELTA shall not be liable for any indirect, incidental,
        consequential, special or exemplary damages arising out of or in connection with
        your use of the Service.
      </p>

      <h2>8. Termination</h2>
      <p>
        KELTA may suspend or terminate your membership for violation of these Terms or
        of association rules and bylaws. Members may also voluntarily withdraw from
        the association at any time by writing to <a href="mailto:keltastate@gmail.com">keltastate@gmail.com</a>.
      </p>

      <h2>9. Changes to the Terms</h2>
      <p>
        KELTA may revise these Terms from time to time. The updated Terms will be
        posted on this page with a revised "Last updated" date. Continued use of the
        Service after such updates constitutes acceptance of the revised Terms.
      </p>

      <h2>10. Governing Law & Jurisdiction</h2>
      <p>
        These Terms are governed by the laws of India. Any dispute arising out of or in
        connection with these Terms shall be subject to the exclusive jurisdiction of
        the courts at Thiruvananthapuram, Kerala.
      </p>

      <h2>11. Contact</h2>
      <p>
        KELTA — Kerala Local Body Technical Assistants Association<br />
        KELTA Office, M.P Building, 12/79 D,<br />
        Vellalassery P.O, N.I.T Via,<br />
        Kozhikode – 673601<br />
        Email: <a href="mailto:keltastate@gmail.com">keltastate@gmail.com</a><br />
        Website: <a href="https://kelta.co.in">kelta.co.in</a>
      </p>
    </LegalPage>
  );
}
